import { ref } from "vue";
import { defineStore } from "pinia";
import { Channel } from "../services/channel"

class CommandChannel extends Channel {
  constructor() {
    super("CommandChannel");
    this.callbacks = {};
  }

  async execute(recordClass, command, params) {
    const command_uuid = crypto.randomUUID();
    const promise = new Promise(async (resolve) => {
      this.callbacks[command_uuid] = (data) => {
        resolve(data);
      };
    });
    this.perform("execute", {
      command_uuid: command_uuid,
      type: recordClass,
      command: command,
      params: params
    });
    return promise;
  }

  received(data) {
    if (data.command_uuid && this.callbacks[data.command_uuid]) {
      this.callbacks[data.command_uuid](data);
      delete this.callbacks[data.command_uuid];
    }
  }
}


export const useCommandStore = defineStore('command', () => {
  const channel = new CommandChannel();
  channel.connect();

  async function execute(recordClass, command, params={}) {
    return channel.execute(recordClass, command, params);
  }

  return {
    execute
  };
});
